import { render, staticRenderFns } from "./ImportDocs.vue?vue&type=template&id=7723247d"
import script from "./ImportDocs.vue?vue&type=script&lang=js"
export * from "./ImportDocs.vue?vue&type=script&lang=js"
import style0 from "./ImportDocs.vue?vue&type=style&index=0&id=7723247d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports